import React, { useState, useRef, useEffect } from "react";
import PageContainer from "@/components/layouts/PageContainer";
import { Heading } from "@/components/heading";
import { Text } from "@/components/text";
import ReactQuill from "react-quill-new";
import "react-quill-new/dist/quill.snow.css";

const QuillTestPage: React.FC = () => {
  const [content, setContent] = useState("");
  const quillRef = useRef<ReactQuill>(null);

  // 기본 모듈 설정
  const modules = {
    toolbar: [["bold", "italic", "underline"], [{ align: [] }], ["clean"]],
    clipboard: {
      matchVisual: false,
      // matchers: [
      //   ["IMG", () => ""], // 이미지 태그를 빈 텍스트로 대체 - 테스트를 위해 제거
      // ],
    },
  };

  // 이미지 차단 로직
  useEffect(() => {
    const setupImageBlocking = () => {
      if (quillRef.current) {
        const quill = quillRef.current.getEditor();
        console.log("Setting up image blocking...");

        // 1. paste 이벤트에서 이미지 차단 (핵심!)
        const pasteHandler = (e: ClipboardEvent) => {
          console.log("Paste event detected");
          const items = e.clipboardData?.items;
          if (items) {
            for (let i = 0; i < items.length; i++) {
              console.log("Clipboard item type:", items[i].type);
              if (items[i].type.indexOf("image") !== -1) {
                console.log("Image detected - blocking paste");
                e.preventDefault();
                e.stopPropagation();
                e.stopImmediatePropagation();
                return false;
              }
            }
          }
        };

        quill.root.addEventListener("paste", pasteHandler, true);
        console.log("Image blocking setup complete");

        return () => {
          quill.root.removeEventListener("paste", pasteHandler, true);
          console.log("Image blocking cleanup");
        };
      }
      return undefined;
    };

    // 약간의 지연을 두고 설정
    const timer = setTimeout(setupImageBlocking, 500);

    return () => {
      clearTimeout(timer);
    };
  }, [content]); // content가 변경될 때마다 재설정

  return (
    <PageContainer>
      <div className="space-y-6">
        <div>
          <Heading>Quill Image Test</Heading>
          <Text className="text-zinc-500">
            Copy and paste an image to test blocking
          </Text>
        </div>

        {/* Quill 에디터 */}
        <div className="border border-gray-300 rounded-lg">
          <ReactQuill
            ref={quillRef}
            theme="snow"
            value={content}
            onChange={setContent}
            modules={modules}
            style={{ minHeight: "300px" }}
          />
        </div>
      </div>
    </PageContainer>
  );
};

export default QuillTestPage;
